import { render, staticRenderFns } from "./IconRejectionFilled.vue?vue&type=template&id=35d90859&"
import script from "./IconRejectionFilled.vue?vue&type=script&lang=js&"
export * from "./IconRejectionFilled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports